import React, { FC } from 'react';
import { ReactComponent as Export } from '../../../assets/ExportButtons/Export.svg';

export const ExportIcon: FC = () => <Export />;
